import script from "./ProgressCircle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgressCircle.vue?vue&type=script&setup=true&lang=ts"

import "./ProgressCircle.vue?vue&type=style&index=0&id=0ddf80f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ddf80f8"]])

export default __exports__